import { serializeParams } from "./request"

export function getParam(name, url) {
  let src = url || window.location.href
  if (name && src) {
    var r = new RegExp("(\\?|#|&|^)" + name + "=([^&^#]*)(#|&|$)")
    var m = src.match(r)
    return !m ? "" : decodeURIComponent(m[2])
  }
  return ""
}

// 获取hash前参数列表
export function getParams(url, decode) {
  url = url || location.href
  var _paramArray = url.replace(/.*?\?/, "").replace(/#.*/, "").split("&")
  var params = {}

  for (var _idx in _paramArray) {
    if (Object.prototype.hasOwnProperty.call(_paramArray, _idx)) {
      var row = _paramArray[_idx]
      var splitIdx = row.indexOf("=")
      if (splitIdx > 0) {
        var key = row.substring(0, splitIdx)
        var value = row.substring(splitIdx + 1)
        if (decode) {
          try {
            value = decodeURIComponent(value)
          } catch (e) {
            value = ""
          }
        }
        params[key] = value
      }
    }
  }
  return params
}

// 获取字符串的参数列表
export function getStrParams(str, decode) {
  var _paramArray = str.split("&")
  var params = {}

  for (var _idx in _paramArray) {
    if (Object.prototype.hasOwnProperty.call(_paramArray, _idx)) {
      var row = _paramArray[_idx]
      var splitIdx = row.indexOf("=")
      if (splitIdx > 0) {
        var key = row.substring(0, splitIdx)
        var value = row.substring(splitIdx + 1)
        if (decode) {
          try {
            value = decodeURIComponent(value)
          } catch (e) {
            value = ""
          }
        }
        params[key] = value
      }
    }
  }
  return params
}

// 解析URL
export function parseURL(url) {
  let a = document.createElement("a")
  a.href = url
  return {
    source: url,
    protocol: a.protocol.replace(":", ""),
    host: a.hostname,
    port: a.port,
    query: a.search,
    params: (function () {
      let ret = {},
        seg = a.search.replace(/^\?/, "").split("&"),
        len = seg.length,
        i = 0,
        s
      for (; i < len; i++) {
        if (!seg[i]) {
          continue
        }
        s = seg[i].split("=")
        ret[s[0]] = s[1]
      }
      return ret
    })(),
    file: (a.pathname.match(/\/([^\/?#]+)$/i) || ["", ""])[1],
    hash: a.hash.replace("#", ""),
    path: a.pathname.replace(/^([^\/])/, "/$1"),
    relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || ["", ""])[1],
    segments: a.pathname.replace(/^\//, "").split("/")
  }
}

/**
 * 删除链接上的参数(支持带hash的链接)
 * @param {*} name 参数名/参数名数组
 * @param {*} url 链接
 */
export function delParam(name, url) {
  if (!(name instanceof Array)) {
    name = [name]
  }

  name.forEach(function (v) {
    url = url.replace(new RegExp("(?:&" + v + "=[^&#]*)", "g"), "")
    url = url.replace(new RegExp("(?:\\?" + v + "=[^&#]*&?)", "g"), "?")
  })
  return url
}

/**
 * 在 url 上添加参数
 * eg: addParam({pf: '__mds_wx_other'}, url)
 * @param arr
 * @param url
 * @return {string|*}
 */
export function addParam(arr, url) {
  var names = Object.keys(arr)

  url = delParam(names, url)
  var postfix = serializeParams(arr)
  url += /(\?|&)$/.test(url) ? "" + postfix : /\?/.test(url) ? "&" + postfix : "?" + postfix
  return url
}

/**
 * 给 url 上增加参数（支持 hash）
 * 参数与 addParam 相同
 * @param arr
 * @param url
 * @return {*}
 */
export function addGetParam(arr, url) {
  // 取出 hash 第一段 & 第二段
  let [prefix, suffix] = url.split("#")

  // 给第一段增加参数
  let addedUrl = addParam(arr, prefix)

  // 若存在第二段，则拼接后返回
  if (suffix) {
    return [addedUrl, "#", suffix].join("")
  }

  return addedUrl
}
